const PostaCellChannelMenuTypes = {
    CHANNEL: {
        id: "detail",
        group: "settings_group",
        path: "detail",
        label: "Detail",
        tabs: [],
        implemented: true,
    },
    BROADCAST_REQUESTS: {
        id: "postacellMessage",
        group: "message_group",
        path: "postacellMessage",
        label: "postacellMessage",
        tabs: [],
        implemented: true,
    },
    BROADCAST: {
        id: "postacellAllMessage",
        group: "message_group",
        path: "postacellAllMessage",
        label: "postacellAllMessage",
        tabs: [],
        implemented: true,
    },

};

export default PostaCellChannelMenuTypes;
